import { DateTimeHelper } from 'src/app/core/helper/datetime.helper';
import { Upload } from 'src/app/core/data/schema/upload';
import { Entity } from 'src/app/core/data/schema/entity';
import { IWinningTicketInfo } from './interfaces';

export class Prize extends Entity {
    static className = 'Prize';
    static idField = 'prizeId';

    name: string;
    drawDate: string;
    prizeId: number;
    raffleId: number;
    category: string;
    drawnBy?: number;
    value: number;
    salesEnd: string;
    image1Path: string;
    image2Path: string;
    image3Path: string;
    image4Path: string;
    lastModified: Date;
    description: string;
    status: PrizeStatus;
    prizeType: PrizeType;
    voidReason: string;
    lastModifiedBy: number;

    deleted: boolean;
    winnerName: string;
    winningNumber: string;
    sortOrder: number;

    endObj: Date;
    endFmt: string;
    drawObj: Date;
    drawFmt: string;
    drawLongFmt: string;
    salesEndFmt: string;

    images: Upload[] = [];

    dispValue = '';
    prizeTypeStr = '';


    // data-table config properties
    customColor = 'dark-color';
    customBtnTxt = 'draw';
    customBtnColor = 'primary';

    constructor(init?: Partial<Prize>) {
        super(Prize.className, Prize.idField);
        Object.assign(this, init);
        this.init();
    }

    static async savePrizeSortOrder(sortOrders: { id: number; sortOrder: number }[]) {
        return await super.factory.httpService.put(sortOrders, `prizes/sortorder`);
    }

    async voidPrize() {
        const resp = await Prize.factory.put(
            'Void',
            this,
            `prizes/${this.prizeId}/void`,
            null,
            'json',
            true);

        return new Prize(resp);
    }

    async drawPrize() {
        return await Prize.factory.post(
            'Draw',
            null,
            `prizes/${this.prizeId}/draw`,
            null,
            null,
            null,
            true,
        ) as IWinningTicketInfo;
    }

    async setWinner(winningTicketNo: string) {
        return await Prize.factory.post(
            'Setting Winner',
            null,
            `prizes/${this.prizeId}/setwinner/${winningTicketNo}`,
            null,
            null,
            false,
            true
        ) as IWinningTicketInfo;
    }

    async save() {
        const result = await super.save();
        if (result) {
            this.init();
        }
        return result;
    }

    canDraw() {
        // can't draw if drawn
        if (this.drawnBy != null) {
            return false;
        }
        // test the draw date
        const endDate = new Date(this.drawDate);
        return endDate.valueOf() < Date.now().valueOf();
    }

    private init() {
        this.refreshDisplayDates();

        this.images = [];

        if (this.value > 0) { this.dispValue = this.prizeType !== PrizeType.fiftyfifty ? this.value.toString() : ''; }
        this.prizeTypeStr = this.prizeType === PrizeType.cash ? 'Cash' : this.prizeType === PrizeType.fiftyfifty ? '50/50' : 'Non-Cash';

        // empty strings are the same as null
        if (this.image1Path === '') { this.image1Path = null; }
        if (this.image2Path === '') { this.image2Path = null; }
        if (this.image3Path === '') { this.image3Path = null; }
        if (this.image4Path === '') { this.image4Path = null; }



        if (!String.isNullOrWhiteSpace(this.image1Path) && !this.image1Path.includes('assets')) {
            this.images.push(new Upload(this.image1Path));
        } else if (this.prizeType === PrizeType.material) {
            // if the prize is material and no image1.. then set
            // a default, do it here so we don't add to the images
            // as it's only for display
            this.image1Path = './assets/img/prize_dflt.png';
        }
        if (!String.isNullOrWhiteSpace(this.image2Path)) {
            this.images.push(new Upload(this.image2Path));
        }
        if (!String.isNullOrWhiteSpace(this.image3Path)) {
            this.images.push(new Upload(this.image3Path));
        }
        if (!String.isNullOrWhiteSpace(this.image4Path)) {
            this.images.push(new Upload(this.image4Path));
        }
    }

    private refreshDisplayDates() {
        // only initialize if hasn't been already.
        if (this.salesEnd != null) {
            if (!this.salesEnd.endsWith('Z')) {
                this.salesEnd += 'Z';
            } // might already have a Z if set from raffle sale end
            this.endObj = new Date(this.salesEnd);
            this.endFmt = DateTimeHelper.formatDateShort(this.salesEnd);

            this.salesEndFmt = DateTimeHelper.formatDate(this.salesEnd);
        }
        if (this.drawDate != null) {
            if (!this.drawDate.endsWith('Z')) {
                this.drawDate += 'Z';
            } // might already have a Z if set from raffle sale end
            this.drawObj = new Date(this.drawDate);
            this.drawFmt = DateTimeHelper.formatDateShort(this.drawDate);
            const fmtDrawDate = DateTimeHelper.formatDate(this.drawDate);
            this.drawLongFmt = fmtDrawDate.slice(-5) === '12 AM' ? this.drawFmt : fmtDrawDate;
        }
    }



}

export enum PrizeType {
    cash = 1,
    material = 2,
    fiftyfifty = 3
}

export enum PrizeStatus {
    pending = 1,
    won = 2,
    void = 3
}
